import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';

import { BuildingAddressFormGroup } from '@features/building/shared/utils/building-address-form.utils';
import { FormFieldComponent } from '@shared/components/form/form-field/form-field.component';
import { FormFieldControlDirective } from '@shared/components/form/form-field/form-field-control.directive';

@Component({
  selector: 'app-building-address-list-editor',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    MessageModule,
    TooltipModule,
    FormFieldComponent,
    FormFieldControlDirective,
  ],
  templateUrl: './building-address-list-editor.component.html',
  styleUrl: './building-address-list-editor.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuildingAddressListEditorComponent {
  @Input({ required: true }) addressesArray!: FormArray<BuildingAddressFormGroup>;
  @Input() disabled = false;
  @Input() title = 'Adresy budynku';
  @Input() addButtonLabel = 'Dodaj adres';
  @Input() removeButtonLabel = 'Usuń';
  @Input() emptyMessage = 'Dodaj co najmniej jeden adres budynku.';
  @Input() fieldIdPrefix = 'building-address';
  @Input() removeDisabledTooltip = 'Istniejących adresów nie można usunąć w tym etapie.';
  @Input() scrollable = false;
  @Input() preservePersistedAddresses = true;
  @Input() rowMotionEnabled = true;

  @Output() addAddress = new EventEmitter<void>();
  @Output() removeAddress = new EventEmitter<number>();

  canRemoveAddress(index: number): boolean {
    const addressId = this.addressesArray.at(index)?.controls.id.value;
    return !this.disabled
      && this.addressesArray.length > 1
      && (!this.preservePersistedAddresses || !addressId);
  }

  getFieldId(field: 'buildingNumber' | 'entranceCode', index: number): string {
    return `${this.fieldIdPrefix}-${field}-${index}`;
  }

  onAddAddress(): void {
    this.addAddress.emit();
  }

  onRemoveAddress(index: number): void {
    if (!this.canRemoveAddress(index)) {
      return;
    }

    this.removeAddress.emit(index);
  }
}
